export default __webpack_public_path__ + "static/media/JoannaLovelace.a05020a6.png";